import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

const initialState = {
    pendingRequests: []
};

export const dataFetchingSlice = createSlice({
    name: 'dataFetching',
    initialState,
    reducers: {
        endFetching: (state, action) => {
            state.pendingRequests = state.pendingRequests.filter(actionName => actionName != action.payload)
        },
        startFetching: (state, action) => {
            state.pendingRequests = [...state.pendingRequests, action.payload]
        }
    }
});

//Export akcji powiązanych z reducerem.
export const { endFetching, startFetching } = dataFetchingSlice.actions;

//Selector do wyboru danych
export const selectPendingRequests = (state) => state.dataFetching.pendingRequests;

export default dataFetchingSlice.reducer; 